module.exports = __webpack_public_path__ + "static/media/m_nose_hawk.ab8c0386.png";